import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import React from 'react';

const PaymentPage = () => {
  return (
    <>
      <Typography variant="h4" sx={{ my: 4 }}>
        {t('common.payments_page')}
      </Typography>
    </>
  );
};

export default PaymentPage;
